module.exports = __webpack_public_path__ + "img/general-info.38e9d1da.svg";